import useFetchWithdrawalRequests from "../../hooks/useFetchWithdrawalRequests";
import { formatCurrency } from "common/utils/currencyFormater";
import StatusComponent from "./StatusComponent";
import { formatTableTimestamp } from "common/utils/dateUtils";
import { toast } from "react-toastify";
import React, { useState } from "react";
import WithdrawalsTableShimmer from "./WithdrawalTableShimmer";

const WithdrawalsTable = ({ campaignId }: { campaignId: string }) => {
    const { withdrawalRequests, isLoading: isWithdrawalRequestsLoading, error: withdrawalRequestsError, refetch } = useFetchWithdrawalRequests(campaignId || "");
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    if (isWithdrawalRequestsLoading) {
        return <WithdrawalsTableShimmer />;
    }

    if (withdrawalRequestsError) {
        toast.error(
            ({ closeToast }) => (
                <div className="flex items-center justify-between gap-2">
                    <span>{withdrawalRequestsError?.message ?? ""}</span>
                    <span
                        onClick={() => {
                            refetch();
                            closeToast();
                        }}
                        className="text-sm cursor-pointer text-black underline hover:text-gray-700"
                    >
                        Reload
                    </span>
                </div>
            ),
            {
                autoClose: false,
                closeOnClick: false,
            },
        );
    };

    return <div className="mx-auto pl-5">
        <>
            <div className="overflow-x-auto rounded-lg lg:flex hidden">
                <table className="w-full border-collapse ">
                    <thead className="h-[36px]">
                        <tr className="text-sm bg-weak-600 text-left text-sub-600">
                            <th className="pl-6 text-body-sm font-thin text-sub-600">
                                Amount
                            </th>
                            <th className="text-body-sm font-thin text-sub-600 sm:table-cell">
                                Giv Charges
                            </th>
                            <th className="text-body-sm font-thin text-sub-600">Bank Charges</th>
                            <th className="text-body-sm font-thin text-sub-600">Amount Received</th>
                            <th className="text-body-sm font-thin text-sub-600">Status</th>
                            <th className="text-body-sm font-thin text-sub-600">
                                TimeStamp
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        {(withdrawalRequests ?? []).map((requests, index) => (
                            <tr key={index} className="border-b hover:bg-gray-50">
                                <td className="mb-5 ml-4 mr-4 mt-6 flex items-center pl-2">
                                    <p className="text-strong-600 text-body-sm">
                                        {formatCurrency((requests.transaction.amount + Number.parseFloat(requests.kro_fee)), true)}
                                    </p>

                                </td>
                                <td className="text-strong-600 hidden w-[325px] text-body-sm sm:table-cell">
                                    {formatCurrency(requests.kro_fee, true)}
                                </td>
                                <td className="text-strong-600 w-[180px] text-body-sm">
                                    {formatCurrency(requests.transaction.fee, true)}
                                </td>
                                <td className="text-strong-600 text-body-sm">
                                    {formatCurrency((requests.transaction.amount - requests.transaction.fee), true)}
                                </td>

                                <td className="text-strong-600 text-body-sm">
                                    <StatusComponent status={requests.status} />
                                </td>
                                <td className="text-strong-600 text-body-sm">
                                    {formatTableTimestamp(requests.created_at)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="lg:hidden ">
                <div className="flex flex-col gap-4 w-full">
                    {withdrawalRequests?.map((requests, index) => {
                        return (
                            <div key={index} className="border border-stroke-soft-200 rounded-[12px] bg-white mb-4 shadow-sm">
                                {/* Top Section */}
                                <div className="flex items-center justify-between p-4">
                                    <div>
                                        <p className="text-[12px] leading-[20px] tracking-[-0.6%] font-medium text-sub-600">{formatCurrency((requests.transaction.amount + Number.parseFloat(requests.kro_fee)), true)}</p>
                                        <p className="text-[12px] leading-[20px] tracking-[-0.6%] text-sub-600">{formatTableTimestamp(requests.created_at)}</p>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <StatusComponent status={requests.status} />
                                        <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="focus:outline-none">
                                            <img src="/assets/icons/Arrow-Down.svg" className={`text-neutral-900 transform transition-transform duration-200 ${openIndex === index ? "rotate-180" : ""}`}
                                                alt="arrow-down" />
                                        </button>
                                    </div>
                                </div>
                                {/* Details Section */}
                                {openIndex === index && (
                                    <div className="border-t px-4 py-3 grid grid-cols-2 gap-y-2">
                                        <div>
                                            <p className="text-[10px] leading-[16px] tracking-[0%] text-sub-600 font-medium">Giv Charges</p>
                                            <p className="text-[12px] leading-[20px] tracking-[-0.6%] font-medium text-sub-600">{formatCurrency(requests.kro_fee, true)}</p>
                                        </div>
                                        <div>
                                            <p className="text-[10px] leading-[16px] tracking-[0%] text-sub-600 font-medium">Bank Charges</p>
                                            <p className="text-[12px] leading-[20px] tracking-[-0.6%] font-medium text-sub-600">{formatCurrency(requests.transaction.fee, true)}</p>
                                        </div>
                                        <div className="col-span-2 mt-2">
                                            <p className="text-[10px] leading-[16px] tracking-[0%] text-sub-600 font-medium">Amount Received</p>
                                            <p className="text-[12px] leading-[20px] tracking-[-0.6%] font-medium text-sub-600">{formatCurrency((requests.transaction.amount - requests.transaction.fee), true)}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </>

    </div>;
};



export default WithdrawalsTable;